export default __webpack_public_path__ + "static/media/as.4d645a17.jpg";